<template>
  <div>
      <div v-for="(objects, obj_name) in content" :key="obj_name">
          <div v-for="(element, name) in objects" :key="name">
            <div v-if="name === 'text'">
                <text-component :text="element"></text-component>
            </div>
            <div v-if="name === 'iframe'">
                <text-component :text="element"></text-component>
            </div>
            <div v-if="name === 'quiz'">
                <quiz-component
                    :quiz_questions="element.questions"
                    :slug_topic="element.slug"
                    @completed="setCompleted" 
                    @attempted="setAttempted"
                    @next="goToNextTopic">
                </quiz-component>
            </div>

            <div v-if="name === 'display-code'">
                <display-code-component :code="element.code" :code_language="element.lang"></display-code-component>
                
            </div>
            
            <div v-if="name === 'completion'">
                <br>
                <div v-if="slug === 'react'">
                    <div v-if="topicCompletedReactArr[element.topicSlug] === 'true'">
                        <lottie class="lottie-anim" :options="defaultOptions" :height="60" :width="60" v-on:animCreated="handleAnimation"/><br>
                        {{element.message}}
                        <br>
                        
                        <PurpleButton
                        buttonText="Next Topic"
                        @pressed="goToNextTopic"></PurpleButton>
                    </div>

                    <PurpleButton v-else 
                        :buttonText="element.buttonText"
                        @pressed="setCompleted(element.topicSlug)">
                    </PurpleButton>

                </div>

                <div v-else-if="slug === 'react-native'">
                    <div v-if="topicCompletedRNArr[element.topicSlug] === 'true'">
                        <lottie class="lottie-anim" :options="defaultOptions" :height="60" :width="60" v-on:animCreated="handleAnimation"/><br>
                        {{element.message}}
                        <br>
                        
                        <PurpleButton
                        buttonText="Next Topic"
                        @pressed="goToNextTopic"></PurpleButton>
                    </div>

                    <PurpleButton v-else 
                        :buttonText="element.buttonText"
                        @pressed="setCompleted(element.topicSlug)">
                    </PurpleButton>

                </div>

                <div v-else-if="slug === 'ui-design'">
                    <div v-if="topicCompletedUIArr[element.topicSlug] === 'true'">
                        <lottie class="lottie-anim" :options="defaultOptions" :height="60" :width="60" v-on:animCreated="handleAnimation"/><br>
                        {{element.message}}
                        <br>
                        
                        <PurpleButton
                        buttonText="Next Topic"
                        @pressed="goToNextTopic"></PurpleButton>
                    </div>

                    <PurpleButton v-else 
                        :buttonText="element.buttonText"
                        @pressed="setCompleted(element.topicSlug)">
                    </PurpleButton>

                </div>

                <div v-else-if="slug === 'modern-javascript'">
                    <div v-if="topicCompletedJSArr[element.topicSlug] === 'true'">
                        <lottie class="lottie-anim" :options="defaultOptions" :height="60" :width="60" v-on:animCreated="handleAnimation"/><br>
                        {{element.message}}
                        <br>
                        
                        <PurpleButton
                        buttonText="Next Topic"
                        @pressed="goToNextTopic"></PurpleButton>
                    </div>

                    <PurpleButton v-else 
                        :buttonText="element.buttonText"
                        @pressed="setCompleted(element.topicSlug)">
                    </PurpleButton>

                </div>
            </div>

          </div>
      </div>
  </div>
</template>

<script>
import TextComponent from './TextComponent.vue'
import QuizComponent from './QuizComponent.vue'
import DisplayCodeComponent from './DisplayCodeComponent.vue'
import PurpleButton from '../components/PurpleButton.vue'
import lottie from 'vue-lottie'
import * as animationData from '../assets/animations/1127-success.json'


export default {
    name: 'ContentComponent',
    components: {
        TextComponent,
        QuizComponent,
        PurpleButton,
        lottie,
        DisplayCodeComponent
    },
    props: {
        content: Array,
        topic: String
    },
    data: function() {
        return {
            defaultOptions: {
                animationData: animationData.default,
                loop: false,
                autoplay: true
            },

            slug: this.$route.params.slug,

            topicCompletedReactArr: {
                'react-intro-to-react': "false",
                'react-components': "false",
                'react-state-and-lifecycle-methods': "false",
                'react-events': "false",
                'react-challenge-1': "false",
                'react-conditional-rendering': "false",
                'react-challenge-2': "false",
                'react-keys-and-lists': "false",
                'react-routing': "false",
                'react-real-world-example-1': "false",
                'react-real-world-example-2': "false",
                'react-real-world-example-3': "false",
                'react-real-world-example-4': "false",
                'react-real-world-example-5': "false"

            },
            topicCompletedRNArr: {
                'react-native-intro-to-react-native': "false",
                'react-native-jsx-props-and-state': "false",
                'react-native-components-and-apis': "false",
                'react-native-view-text-and-image': "false",
                'react-native-style-and-flexbox': "false",
                'react-native-scrollview-and-listviews': "false",
                'react-native-networking-apis': "false",
                'react-native-routing': "false",
                'react-native-real-world-example-1': "false",
                'react-native-real-world-example-2': "false",
                'react-native-real-world-example-3': "false",
                'react-native-real-world-example-4': "false",
                'react-native-real-world-example-5': "false"

            },
            topicCompletedUIArr: {
                'ui-design-intro-to-ui-design': "false",
                'ui-design-simplicity-over-complexity': "false",
                'ui-design-outcomes-over-features': "false",
                'ui-design-visual-hierarchy': "false",
                'ui-design-alignment': "false",
                'ui-design-focal-points': "false",
                'ui-design-contrast': "false",
                'ui-design-dominance': "false",
                'ui-design-rythm': "false"
            },
            topicCompletedJSArr: {
                'modern-js-intro-to-modern-js': "false"
            }

        }
    },
    created: function() {
        if (localStorage !== undefined) {
            //React topics, should add all this to Vuex
            if (localStorage.getItem('react-intro-to-react'))
                this.topicCompletedReactArr['react-intro-to-react'] = localStorage.getItem('react-intro-to-react');

            if (localStorage.getItem('react-components'))
                this.topicCompletedReactArr['react-components'] = localStorage.getItem('react-components');

            if (localStorage.getItem('react-state-and-lifecycle-methods'))
                this.topicCompletedReactArr['react-state-and-lifecycle-methods'] = localStorage.getItem('react-state-and-lifecycle-methods');

            if (localStorage.getItem('react-events'))
                this.topicCompletedReactArr['react-events'] = localStorage.getItem('react-events');

            if (localStorage.getItem('react-challenge-1'))
                this.topicCompletedReactArr['react-challenge-1'] = localStorage.getItem('react-challenge-1');

            if (localStorage.getItem('react-conditional-rendering'))
                this.topicCompletedReactArr['react-conditional-rendering'] = localStorage.getItem('react-conditional-rendering');

            if (localStorage.getItem('react-keys-and-lists'))
                this.topicCompletedReactArr['react-keys-and-lists'] = localStorage.getItem('react-keys-and-lists');

            if (localStorage.getItem('react-challenge-2'))
                this.topicCompletedReactArr['react-challenge-2'] = localStorage.getItem('react-challenge-2');

            if (localStorage.getItem('react-routing'))
                this.topicCompletedReactArr['react-routing'] = localStorage.getItem('react-routing');

            if (localStorage.getItem('react-real-world-example-1'))
                this.topicCompletedReactArr['react-real-world-example-1'] = localStorage.getItem('react-real-world-example-1');

            if (localStorage.getItem('react-real-world-example-2'))
                this.topicCompletedReactArr['react-real-world-example-2'] = localStorage.getItem('react-real-world-example-2');

            if (localStorage.getItem('react-real-world-example-3'))
                this.topicCompletedReactArr['react-real-world-example-3'] = localStorage.getItem('react-real-world-example-3');

            if (localStorage.getItem('react-real-world-example-4'))
                this.topicCompletedReactArr['react-real-world-example-4'] = localStorage.getItem('react-real-world-example-4');

            if (localStorage.getItem('react-real-world-example-5'))
                this.topicCompletedReactArr['react-real-world-example-5'] = localStorage.getItem('react-real-world-example-5');


            
            //React Native topics
            if (localStorage.getItem('react-native-intro-to-react-native'))
                this.topicCompletedRNArr['react-native-intro-to-react-native'] = localStorage.getItem('react-native-intro-to-react-native');

            if (localStorage.getItem('react-native-jsx-props-and-state'))
                this.topicCompletedRNArr['react-native-jsx-props-and-state'] = localStorage.getItem('react-native-jsx-props-and-state');

            if (localStorage.getItem('react-native-components-and-apis'))
                this.topicCompletedRNArr['react-native-components-and-apis'] = localStorage.getItem('react-native-components-and-apis');

            if (localStorage.getItem('react-native-view-text-and-image'))
                this.topicCompletedRNArr['react-native-view-text-and-image'] = localStorage.getItem('react-native-view-text-and-image');

            if (localStorage.getItem('react-native-style-and-flexbox'))
                this.topicCompletedRNArr['react-native-style-and-flexbox'] = localStorage.getItem('react-native-style-and-flexbox');

            if (localStorage.getItem('react-native-scrollview-and-listviews'))
                this.topicCompletedRNArr['react-native-scrollview-and-listviews'] = localStorage.getItem('react-native-scrollview-and-listviews');

            if (localStorage.getItem('react-native-routing'))
                this.topicCompletedRNArr['react-native-routing'] = localStorage.getItem('react-native-routing');

            if (localStorage.getItem('react-native-networking-apis'))
                this.topicCompletedRNArr['react-native-networking-apis'] = localStorage.getItem('react-native-networking-apis');


            if (localStorage.getItem('react-native-real-world-example-1'))
                this.topicCompletedRNArr['react-native-real-world-example-1'] = localStorage.getItem('react-native-real-world-example-1');

            if (localStorage.getItem('react-native-real-world-example-2'))
                this.topicCompletedRNArr['react-native-real-world-example-2'] = localStorage.getItem('react-native-real-world-example-2');

            if (localStorage.getItem('react-native-real-world-example-3'))
                this.topicCompletedRNArr['react-native-real-world-example-3'] = localStorage.getItem('rreact-native-real-world-example-3');

            if (localStorage.getItem('react-native-real-world-example-4'))
                this.topicCompletedRNArr['react-native-real-world-example-4'] = localStorage.getItem('react-native-real-world-example-4');

            if (localStorage.getItem('react-native-real-world-example-5'))
                this.topicCompletedRNArr['react-native-real-world-example-5'] = localStorage.getItem('react-native-real-world-example-5');


            //UI Design topics
            if (localStorage.getItem('ui-design-intro-to-ui-design'))
                this.topicCompletedUIArr['ui-design-intro-to-ui-design'] = localStorage.getItem('ui-design-intro-to-ui-design');

            if (localStorage.getItem('ui-design-simplicity-over-complexity'))
                this.topicCompletedUIArr['ui-design-simplicity-over-complexity'] = localStorage.getItem('ui-design-simplicity-over-complexity');

            if (localStorage.getItem('ui-design-outcomes-over-features'))
                this.topicCompletedUIArr['ui-design-outcomes-over-features'] = localStorage.getItem('ui-design-outcomes-over-features');

            if (localStorage.getItem('ui-design-visual-hierarchy'))
                this.topicCompletedUIArr['ui-design-visual-hierarchy'] = localStorage.getItem('ui-design-visual-hierarchy');

            if (localStorage.getItem('ui-design-alignment'))
                this.topicCompletedUIArr['ui-design-alignment'] = localStorage.getItem('ui-design-alignment');

            if (localStorage.getItem('ui-design-focal-points'))
                this.topicCompletedUIArr['ui-design-focal-points'] = localStorage.getItem('ui-design-focal-points');

            if (localStorage.getItem('ui-design-contrast'))
                this.topicCompletedUIArr['ui-design-contrast'] = localStorage.getItem('ui-design-contrast');

            if (localStorage.getItem('ui-design-dominance'))
                this.topicCompletedUIArr['ui-design-dominance'] = localStorage.getItem('ui-design-dominance');

            if (localStorage.getItem('ui-design-rythm'))
                this.topicCompletedUIArr['ui-design-rythm'] = localStorage.getItem('ui-design-rythm');
        

        }

    },
    methods: {
        setCompleted(slug_topic) {
            localStorage.setItem(slug_topic, "true");
            console.log("inside setCompleted of setLearning, slug_topic is " + slug_topic);

            if (this.slug === 'react')
                this.topicCompletedReactArr[slug_topic] = "true";

            else if (this.slug === 'react-native')
                this.topicCompletedRNArr[slug_topic] = "true";

            else if (this.slug === 'ui-design')
                this.topicCompletedUIArr[slug_topic] = "true";
           
        },

        setAttempted(slug_topic, score) {
            localStorage.setItem(slug_topic, score);
            console.log("inside setAttempted of setLearning, slug_topic is " + slug_topic + " score is " + score);
            
            if (this.slug === 'react')
                this.topicCompletedReactArr[slug_topic] = score;

            else if (this.slug === 'react-native')
                this.topicCompletedRNArr[slug_topic] = score;
            
        },

        handleAnimation: function(anim) {
            this.anim = anim;
        },

        goToNextTopic() {
            this.$emit('next');
        }
    }
}
</script>

<style>

    .lottie-anim {
        margin: 0px !important;
    }

</style>